/**
 * PowerupsSection — cached course powerups with position.
 */

import React from 'react';
import { Section, Row } from '../RaceDebugPrimitives';

const COLOR = '#f39c12';

interface PowerupLike {
  id: string;
  kind: string;
  x: number;
  y: number;
}

export const PowerupsSection: React.FC<{
  powerups: PowerupLike[];
}> = ({ powerups }) => (
  <Section title={`Powerups (${powerups.length})`} color={COLOR}>
    {powerups.length === 0
      ? <Row label="—" value="none cached" valueColor="#666" />
      : powerups.map((p) => (
        <Row key={p.id}
             label={p.kind}
             value={`(${p.x},${p.y})`} />
      ))}
  </Section>
);
